var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"application-by-id"},[_c('page-title',{attrs:{"title":"ApplicationById Component"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }